 
import AgGridWrapper from './AgGridWrapper';
import { Row } from 'react-bootstrap';
import type { IDetailCellRendererParams } from 'ag-grid-community';
import type {
  AgGridColumn,
  AgGridMasterDetailItem
} from './types';

type AgGridMasterDetailsProps = {
  data: AgGridMasterDetailItem;
  masterDetailData?: unknown;
} & Partial<Pick<IDetailCellRendererParams<AgGridMasterDetailItem>, 'node' | 'api'>>;

type AgGridMasterDetailData = AgGridMasterDetailItem & {
  children?: AgGridMasterDetailItem[];
};

const AgGridMasterDetails = ({
  data,
  masterDetailData
}: AgGridMasterDetailsProps) => {
  let updatedMasterDetailData:
    | AgGridMasterDetailItem[]
    | AgGridMasterDetailData = data;
  if (location.pathname.includes('/crawl/check-list/')) {
    updatedMasterDetailData = (masterDetailData as AgGridMasterDetailItem[]).map(
      item => {
        return {
          ...item,
          additionalData: {
            ...item.additionalData,
            group_id: data[item.targetParam as string]
          }
        };
      }
    );
  } else if (location.pathname.includes('/keyword-research/clustering/')) {
    updatedMasterDetailData = data;
  }
  const clusteringData = updatedMasterDetailData as AgGridMasterDetailData;
  return (
    <>
      {/* CHECKLIST */}
      <Row className="px-3">
        <div className="m-auto my-2">
          با پوزش بسیار از شما این بخش نیاز به تغییرات و بهینه سازی دارد. از
          شکیبایی شما سپاس گذارم.
        </div>
      </Row>
      {/* CLUSTERIG */}
      <style>{`#headerHider .ag-root .ag-header {display: none;padding-right:27px;}`}</style>
      <style>
        {`#headerHider .ag-icon-tree-closed {
          padding-left:15px;
          display: ${'block'};
        }`}
      </style>
      <div id="headerHider">
        {location.pathname.includes('/keyword-research/clustering/') && (
          <AgGridWrapper
            height="300px"
            columns={
              [
              {
                field: 'name',
                flex: 1,
                type: 'string',
                title: 'کلمه',
                cellRenderer: clusteringData.children
                  ? 'agGroupCellRenderer'
                  : (params: { value: unknown }) => (
                      <div>{decodeURIComponent(params.value as string)}</div>
                    )
              }
              ] as AgGridColumn[]
            }
            settings={{
              masterDetail: clusteringData.children ? true : false
            }}
            data={
              clusteringData.children
                ? clusteringData.children
                : [clusteringData]
            }
          />
        )}
      </div>
    </>
  );
};

export default AgGridMasterDetails;
